var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "d-flex my-3 align-items-center",
      class: { "has-error": _vm.hasErrors },
    },
    [
      _c("div", { staticClass: "input-file__filename" }, [
        _vm._v(_vm._s(_vm.file.name)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "input-file__buttons" }, [
        !_vm.file.name
          ? _c(
              "span",
              { staticClass: "input-file__btn btn btn-default d-none" },
              [_vm._v(_vm._s(_vm.$t("input_file_choose")))]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.file.name
          ? _c("input", {
              ref: "file",
              attrs: {
                type: "file",
                title:
                  "Przeglądaj swój dysk aby wybrać plik, który chcesz dołączyć do zgłoszenia.",
              },
              on: { change: _vm.addFile },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.file.name
          ? _c(
              "a",
              {
                staticClass:
                  "input-file__btn-remove btn btn-danger py-1 p-2 ms-3 rounded-3",
                attrs: { href: "#", title: _vm.$t("input_file_remove") },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("file:remove", _vm.idx)
                  },
                },
              },
              [
                _c("i", { staticClass: "bi bi-trash" }),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.file.name)),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasErrors
        ? _c("label", [_vm._v(_vm._s(_vm.activeErrorMessages[0]))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }